
<template>
<v-app>
  <cabecera/>
    <v-main style="background-color:#6D9886;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container>
    <section id="main-cabecera" class="mb-4">
       <v-row align="center" class="text-center">
        <v-col cols="12" sm="12" md="12" lg="12">
        <h1 class="display-2 font-weight-bold mb-3">
          URL Instrucciones de Eliminación de Datos
        </h1>
        </v-col>
    <v-col cols="12" sm="12" md="12" lg="12">
      <p class="text-lg-justify text-justify">
        En concordancia con las regulaciones de Facebook para Apps y sitios web, debemos brindarle a los usuarios las instrucciones para eliminar sus datos. Si quieres eliminar tu actividad relacionada al Tunay App, lo puedes hacer de la siguiente manera.      </p>
      <p>
        1. Ingresa a tu cuenta de Facebook y haz clic en “Configuración y privacidad”. Después haz clic en “Configuración”.
      </p>
      <p>
        2. Ve a la sección de “Apps y sitios web”, aquí podrás ver toda tu actividad relacionada a aplicaciones y páginas web registradas en tu cuenta de Facebook.
      </p>
      <p>
        3. Buscar Tunay y dar click al botón Eliminar
      </p>
      <p>
        <v-img src="@/assets/eliminartunay.png"></v-img>
      </p>
      <p>
        4. Seleccionar ambas opciones y dar Click en Eliminar
      </p>
      <p>
        5. Se elimino con exito Tunay de tus aplicaciones!
      </p>
          </v-col>


       </v-row>
    </section>


  </v-container>
    </v-main>
    <piepagina/>
  </v-app>
</template>

<script>

import cabecera from '../general/cabecera';
import piepagina from '../general/piepagina';
import Cabecerabaja from "@/components/general/cabecerabaja";
  export default {
    name: 'eliminarfacebook',
    components: {
      Cabecerabaja,
    cabecera,
    piepagina,
  },
    data () {
      return {
        clientesimg: [],
        email: '',
        emailRules: [
          v => !!v || 'Se necesita el Email',
          v => /.+@.+/.test(v) || 'E-mail debe ser valido',
        ]
          }
    },
    mounted(){

      console.log(process.env.VUE_APP_ROOT_API)
    },
    methods: {

    },
  }
</script>
